import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import api from '../../config/axions.config';
import { toast } from 'sonner';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { showDate } from '../../constant';

const FinanceReports = () => {
  let navigate = useNavigate();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [financeReportData, setFinanceReportData] = useState([])
  const getFinanceReport = async () => {
    try {
      console.log("start date :", startDate, "end date :", endDate)
      if (!startDate || !endDate) toast.error("Some Fields Are Empty.")
      let responce = await api.get(`enrollment/financeReport`,
        {
          params: {
            startDate: startDate,
            endDate: endDate
          }
        })
      if (responce.data.status) {
        toast.success(responce.data.message);
        setFinanceReportData(responce.data.data)
      } else {
        toast.error(responce.data.message);
      }
    } catch (error) {
      console.error(error)
      toast.error(error.response.data.message);
      let list = error.response.data.errors || [];
      for (let item of list) {
        toast.warning(item.msg)
      }
    }
  }
  return (
    <div>
      <div className='grow ms-0 md:ms-0 lg:ms-56'>
        <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
          <div className='flex items-center justify-end lg:justify-between'>
            <h1 className="hidden text-2xl font-semibold text-primary-600 lg:block">
              Finance Reports
            </h1>
          </div>

          <div className="space-y-6 lg:mt-6">
            <div className="overflow-hidden bg-white rounded-lg shadow">
              <div className="px-4 py-5 sm:px-6">
                <div className="flex justify-between">
                  <div className='flex space-x-5'>
                    <div className="flex items-center space-x-2">
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        disabledKeyboardNavigation
                        placeholderText="Start Date"
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>

                    <div className="flex items-center space-x-2">
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        disabledKeyboardNavigation
                        placeholderText="End Date"
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>
                  </div>
                  <div className='flex space-5'>
                    <div className='px-2 pr-2'>
                      <button onClick={getFinanceReport} className='btn btn-primary'>
                        Search
                      </button>
                    </div>
                    <div className='px-2 pr-2'>
                      <button className='btn btn-primary'>
                        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M19 15V17C19 18.1046 18.1046 19 17 19H7C5.89543 19 5 18.1046 5 17V15M12 5V15M12 15L10 13M12 15L14 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Download
                      </button>
                    </div>
                  </div>
                </div>

              </div>

              <div className="flex flex-col">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <div className="overflow-hidden">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th scope="col" className="col">
                              New Admission
                            </th>
                            <th scope="col">
                              Fresh Business
                            </th>
                            <th scope="col">
                              Total Collection
                            </th>
                            <th scope="col">
                              Google Pay
                            </th>
                            <th scope="col">
                              Phone Pe
                            </th>
                            <th scope="col">
                              Cash
                            </th>
                            <th scope="col">
                              Cheque
                            </th>
                            <th scope="col">
                              UPI
                            </th>
                            <th scope="col">
                              Paytm
                            </th>
                            <th scope="col">
                              Net Banking
                            </th>
                            <th scope="col">
                              Expense
                            </th>
                            <th scope="col">
                              View
                            </th>
                            <th scope="col">
                              Delete
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                         {
                          financeReportData.length > 0 ? financeReportData.map((item,index)=>
                            <tr key={index}>
                            <td>
                              <div className="flex items-center">
                                <div className="flex-1 min-w-0 ml-2">
                                  <div title="" className="font-medium truncate hover:text-primary-600 w-36 sm:w-auto line-clamp-1">
                                    {item?.new_admissions}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="whitespace-nowrap">
                              {item?.fresh_business}
                            </td>
                            <td className="whitespace-nowrap">
                              {item?.total_collection}
                            </td>
                            <td className="whitespace-nowrap">
                              {item?.google_pay}
                            </td>
                            <td className="whitespace-nowrap">
                              {item?.phone_pe}
                            </td>
                            <td className="whitespace-nowrap">
                              {item?.cash}
                            </td>
                            <td className="whitespace-nowrap">
                              {item?.cheque}
                            </td>
                            <td className="whitespace-nowrap">
                              {item?.upi}
                            </td>
                            <td className="whitespace-nowrap">
                              {item?.paytm}
                            </td>
                            <td className="whitespace-nowrap">
                              {item.net_banking}
                            </td>
                            <td className="whitespace-nowrap">
                              {item.total_expense}
                            </td>
                            <td className="whitespace-nowrap cursor-pointer" onClick={() => navigate('/dashboard/view-finance-report/', { state: item })}>
                              <svg fill="#000000" className="w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m23.589 22.261-2.102-2.101c.51-.769.814-1.713.814-2.728 0-2.389-1.683-4.385-3.929-4.866l-.033-.006v-4.043c0-.009 0-.018 0-.026 0-.246-.088-.471-.233-.646l.001.002v-.005c-.019-.023-.039-.045-.06-.066l-.008-.009c-.009-.009-.018-.018-.027-.027l-7.44-7.44c-.021-.021-.042-.04-.065-.059l-.026-.018c-.016-.013-.033-.026-.05-.038l-.025-.018c-.018-.012-.036-.022-.054-.034l-.023-.012q-.034-.02-.075-.037l-.032-.013-.051-.018-.036-.011-.058-.015-.028-.006c-.028-.006-.057-.01-.086-.013h-8.948c-.559.002-1.011.454-1.015 1.012v20.377c0 .561.454 1.017 1.015 1.019h16.306.004c1.013 0 1.955-.304 2.74-.827l-.018.011 2.102 2.102c.181.166.423.268.689.268.563 0 1.019-.456 1.019-1.019 0-.266-.102-.508-.269-.689l.001.001zm-3.325-4.827c0 1.625-1.318 2.943-2.943 2.943s-2.943-1.318-2.943-2.943 1.318-2.943 2.943-2.943c1.624.002 2.941 1.318 2.943 2.942zm-9.396-13.956 3.993 3.994h-3.993zm-8.83-1.44h6.793v6.453c0 .563.456 1.019 1.019 1.019h6.453v3.05c-2.278.487-3.962 2.483-3.962 4.873 0 1.109.362 2.133.975 2.96l-.01-.013h-11.269z"/></svg>
                            </td>
                            <td className="whitespace-nowrap cursor-pointer">
                              <svg className="w-5 h-5" stroke="currentColor" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 7V18C6 19.1046 6.89543 20 8 20H16C17.1046 20 18 19.1046 18 18V7M6 7H5M6 7H8M18 7H19M18 7H16M10 11V16M14 11V16M8 7V5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V7M8 7H16" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            </td>
                          </tr>
                          ):
                          (
                            <tr className='text-center w-full'>
                              <td className='w-full text-center p-7 text-xl'>Choose data and search</td>
                            </tr>
                          )
                         }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FinanceReports
